import { HANDLED_BILL_SHOCK_TRANSFO_ERRORS } from 'pages/app/billing/billing-cycles/components/billshock-error/constants.ts'

/**
 * Type-guard for the handled Transfo errors displayed for bill shock
 * @param {string} errorCode
 * @returns {errorCode is (typeof HANDLED_BILL_SHOCK_TRANSFO_ERRORS)[number]}
 */
export const isHandledBillShockTransfoError = (errorCode?: string): errorCode is (typeof HANDLED_BILL_SHOCK_TRANSFO_ERRORS)[number] => {
  if (!errorCode || typeof errorCode !== 'string') return false
  return HANDLED_BILL_SHOCK_TRANSFO_ERRORS.some((code) => code === errorCode)
}
